import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-linkedin",
  "use": "social-media-linkedin-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"social-media-linkedin\"><path d=\"M170 0H30A30.09 30.09 0 000 30v140a30.09 30.09 0 0030 30h140a30.09 30.09 0 0030-30V30a30.09 30.09 0 00-30-30zm-53.5 152.05H110q-7.94 0-13.09-4.09-5.43-4.15-5.43-14v-86.8H106v85.68q0 5.11 5.45 5.11h5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol